export { default } from './BannerAppSmart';
